import React, { Component } from 'react';
import { connect } from 'react-redux';

import helpers from 'utils/helpers';
import { getQuotationRequest } from 'ducks/shipments';
import { StyledButton } from 'components/Styled';

class QuotationButton extends Component {
  handleClick = () => {
    const { totalBox, totalWeight } = this.props.boxData;

    if (!totalBox || !totalWeight) {
      helpers.message.error(
        this.props.t('quotation.err_msg.empty_quantity_weight'),
        'quotation'
      );
      this.props.validateTotalWeight();
      return;
    }

    if (!this.props.origin || !this.props.destination) {
      helpers.message.error(
        this.props.t('quotation.err_msg.empty_countries'),
        'quotation'
      );
      this.props.validateCountries();
      return;
    }

    this.props.getQuotationRequest({
      origin: this.props.origin,
      destination: this.props.destination,
      boxData: this.props.boxData
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { totalWeight, totalVolumeWeight } = this.props.boxData;

    if (!prevProps.autosaveLoaded && this.props.autosaveLoaded) {
      if (totalWeight && totalVolumeWeight) {
        this.handleClick();
      }
    }
  }

  render() {
    const {
      totalWeight,
      totalVolumeWeight,
      previewWeight
    } = this.props.boxData;

    const useVolumeWeight =
      totalVolumeWeight && totalWeight && totalVolumeWeight > totalWeight;
    const useActualWeight =
      totalVolumeWeight && totalWeight && totalVolumeWeight <= totalWeight;

    return (
      <div
        style={{
          paddingTop: '20px'
        }}>
        <StyledButton
          disabled
          onClick={this.handleClick}
          type="primary"
          loading={this.props.loading || !this.props.autosaveLoaded}
          shadow="true"
          block>
          {useVolumeWeight || useActualWeight
            ? this.props.t('quotation.calculate_rates_by_kg', {
                weight: previewWeight
              })
            : this.props.t('quotation.express_budget')}
        </StyledButton>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.shipments.loading
  };
};

const mapDispatchToProps = {
  getQuotationRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotationButton);
